import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import './embed.css';

const POOL = [
  '/monitor/index.html',
  '/embed/leaderboard-logo',
  '/embed/dashboard',
  '/embed/dashboard?chart=false',
  '/embed/leaderboard?limit=50&style=compact',
  '/embed/market?chart=true',
  '/embed/market?chart=false',
  '/embed/random-stocks',
  '/embed/random-detail?variant=full',
  '/embed/trades-table',
  '/embed/events-table',
  '/embed/recent-trades',
  '/embed/countdown',
  'https://komokshow.netlify.app/simulate/?broadcast=true&displayMode=video-composite',
];

// Layout definitions using CSS grid template areas
const LAYOUTS = [
  // 1 big left, 2 stacked right (like the screenshot)
  { panels: 3, grid: '"a b" "a c"', cols: '1fr 1fr', rows: '1fr 1fr' },
  // 2 stacked left, 1 big right
  { panels: 3, grid: '"a b" "c b"', cols: '1fr 1fr', rows: '1fr 1fr' },
  // 1 big top, 2 side-by-side bottom
  { panels: 3, grid: '"a a" "b c"', cols: '1fr 1fr', rows: '1fr 1fr' },
  // 2 side-by-side top, 1 big bottom
  { panels: 3, grid: '"a b" "c c"', cols: '1fr 1fr', rows: '1fr 1fr' },
  // 2x2 grid
  { panels: 4, grid: '"a b" "c d"', cols: '1fr 1fr', rows: '1fr 1fr' },
  // 1 big left, 3 stacked right
  { panels: 4, grid: '"a b" "a c" "a d"', cols: '1.5fr 1fr', rows: '1fr 1fr 1fr' },
  // 3 stacked left, 1 big right
  { panels: 4, grid: '"a b" "c b" "d b"', cols: '1fr 1.5fr', rows: '1fr 1fr 1fr' },
  // 50/50 split
  { panels: 2, grid: '"a b"', cols: '1fr 1fr', rows: '1fr' },
  // top/bottom split
  { panels: 2, grid: '"a" "b"', cols: '1fr', rows: '1fr 1fr' },
  // 1 big top, 3 bottom
  { panels: 4, grid: '"a a a" "b c d"', cols: '1fr 1fr 1fr', rows: '2fr 1fr' },
];

const AREA_NAMES = ['a', 'b', 'c', 'd'];

function pickUnique(count, exclude) {
  const picks = [];
  const used = new Set(exclude || []);
  while (picks.length < count) {
    const pick = POOL[Math.floor(Math.random() * POOL.length)];
    if (!used.has(pick)) {
      picks.push(pick);
      used.add(pick);
    }
    // If pool is exhausted, allow duplicates
    if (used.size >= POOL.length) used.clear();
  }
  return picks;
}

const EmbedMultiScreen = () => {
  const [searchParams] = useSearchParams();
  const interval = parseInt(searchParams.get('interval')) || 120000; // 2 min default

  const [layout, setLayout] = useState(() => LAYOUTS[Math.floor(Math.random() * LAYOUTS.length)]);
  const [pages, setPages] = useState(() => pickUnique(layout.panels));
  const [key, setKey] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      const newLayout = LAYOUTS[Math.floor(Math.random() * LAYOUTS.length)];
      setLayout(newLayout);
      setPages(pickUnique(newLayout.panels));
      setKey(k => k + 1);
    }, interval);
    return () => clearInterval(timer);
  }, [interval]);

  return (
    <div
      className="embed-multiscreen"
      style={{
        gridTemplateAreas: layout.grid,
        gridTemplateColumns: layout.cols,
        gridTemplateRows: layout.rows,
      }}
    >
      <button className="embed-fullscreen-btn embed-fullscreen-corner" onClick={() => document.documentElement.requestFullscreen?.()}>&#x26F6;</button>

      {pages.map((page, i) => (
        <div
          key={`${key}-${i}`}
          className="embed-multiscreen-panel"
          style={{ gridArea: AREA_NAMES[i] }}
        >
          <iframe
            src={page}
            title={`Panel ${i + 1}`}
            allowFullScreen
          />
        </div>
      ))}
    </div>
  );
};

export default EmbedMultiScreen;
